import Head from 'next/head';

import { CmsRecipePageDocument } from '@interfaces/common';
import { minutesToISODuration } from '@utils/date';

export const RecipeStructuredData: React.VFC<CmsRecipePageDocument> = ({
	image,
	totalTime,
	serves,
	categories,
	cuisine,
	ingredients,
	instructions,
	metadata: { title, description },
	_createdAt,
}) => {
	const structuredData = {
		'@context': 'https://schema.org/',
		'@type': 'Recipe',
		name: title,
		image: [image.src],
		datePublished: _createdAt,
		description,
		totalTime: minutesToISODuration(totalTime),
		recipeYield: serves,
		recipeCategory: categories?.map(({ title: name }) => name).join(', '),
		recipeCuisine: cuisine?.title,
		recipeIngredient: ingredients
			.map(({ title: name, quantity }) => `${quantity} ${name}`)
			.join(', '),
		recipeInstructions: instructions.map(({ text, title: name }) => ({
			'@type': 'HowToStep',
			name,
			text,
		})),
	};

	return (
		<Head>
			<script
				dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
				type="application/ld+json"
			/>
		</Head>
	);
};
